<template>
    <div>
        <div class="photo-main clearfix">
            <div class="photo-box">
                <div class="photo-div" v-for="(item,i) in imgData" v-bind:key="i">
                    <van-icon class="photo-del" name="cross"  @click.native="del(i)"/>
                    <div class="photo-img"
                        v-bind:style="{
                            backgroundImage:'url('+item+')',
                            backgroundSize:'cover',
                            backgroundRepeat:'no-repeat'}"
                        @click="enlarge(item)"></div>
                </div>

                <div class="photo-div add-photo" v-if="isAdd">
                    <img class="add-photo-img" src="@/assets/infoPublic/images/add-photo.png" />
                    <input ref="referenceUpload"
                        type="file"
                        multiple
                        name="myPhoto"
                        @change="addPhoto($event)"
                        id="referenceUpload"
                        onfocus="this.blur()"
                        style="position:absolute;top:0px;left:0px;width:100%;height:100%;opacity:0;" />
                </div>
            </div>
            <van-popup v-model="showImg" position="center" style="width:100%">
                <img class="photo-big" v-bind:src="itemImg" />
            </van-popup>
            <van-button type="info" size="large" @click.native="creatUser" class="creatBtn">发布到班牌</van-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "SendPic",
    data() {
        return {        
            filesUrls :[],
            imgData: [],
            showImg: false,
            itemImg: '',
            isAdd:true,
            type:9,
        };
    },
    computed: {
    },
    created () {
        var filesUrls = this.$store.state.infoPublic.PicfilesUrls;
        for (var i = 0; i < filesUrls.length; i++) {
            this.filesUrls.push(filesUrls[i]);
        }
        console.log(this.filesUrls);
    },
    mounted () {
        this.loadList();
    },
    methods: {
        // 获取传过来的照片数组
        loadList () {
            if (this.filesUrls.length < 21) {
                this.isAdd = true;
            } else {
                this.isAdd = false;
            }
            // 路径转换
            this.transformFileToDataUrl(this.filesUrls);
        },

        // 路径转换
        transformFileToDataUrl (file) {
            var imgList = [];
            for (var i = 0; i < file.length; i++) {
                // 封装好的函数
                var reader = new FileReader();
                reader.readAsDataURL(file[i]);
                // file转dataUrl是个异步函数，要将代码写在回调里
                reader.onload = function (e) {
                    var result = e.target.result;
                    imgList.push(result);
                };
            }
            this.imgData = imgList;
        },

        // 删除照片
        del (val) {
            this.imgData.splice(val, 1);
            this.filesUrls.splice(val, 1);
            if (this.filesUrls.length < 21) {
                this.isAdd = true;
            } else {
                this.isAdd = false;
            }
        },


        // 添加照片
        addPhoto (event) {
            
            var filesUrls = event.target.files;
            var imgMasSize = 1024 * 1024 * 10; // 10MB
            var totalSize = 0;
            if (filesUrls.length > 20) {
                this.xy.msgError("最多只能上传20张图片");
                return;
            }
            for (var i = 0; i < filesUrls.length; i++) {
                totalSize+=filesUrls[i].size
                if (['jpeg', 'png', 'bmp', 'jpg'].indexOf(filesUrls[i].type.split("/")[1]) < 0) {
                    // 自定义报错方式
                    this.xy.msgError("文件类型仅支持 jpeg/png/jpg/bmp");
                    return;
                }

                if (filesUrls[i].size > imgMasSize) {
                    // 文件大小自定义限制
                    this.xy.msgError("文件大小不能超过10MB");
                    return;
                }
            }
            if(totalSize>(1024 * 1024 * 20)){
                this.xy.msgError("图片总大小不能超过20MB");
                return; 
            }
            if (filesUrls.length + this.filesUrls.length > 20) {
                this.xy.msgError("最多只能上传20张图片");
                return;
            } else {
                var addFiles = [];
                for (let i = 0; i < filesUrls.length; i++) {
                    addFiles.push(filesUrls[i]);
                }
                for (let c in addFiles) {
                    this.filesUrls.push(addFiles[c]);
                }

                if (this.filesUrls.length < 21) {
                    this.isAdd = true;
                } else {
                    this.isAdd = false;
                }

                //图片压缩
                this.transformFileToDataUrl(this.filesUrls);
            }
        },


        // 发送到班牌
        creatUser () {
            var classTerminal = [];
            this.$store.commit('infoPublic/setPicfilesUrls', this.filesUrls);
            this.$store.commit('infoPublic/settypePic', this.type);
            this.$store.commit('infoPublic/setclassTerminal', classTerminal);
            this.$router.push('/home/SelectClassCard');
        },

        // 点击图片放大
        enlarge (val) {
            this.itemImg = val;
            this.showImg = true;
        },

    }
};
</script>
<style lang="less" scoped>
.photo-main {
    background: #fff;
}
    .photo-main > .photo-box {
        width:84%;
        margin:0 auto;
        margin-top:25px;
    }
        .photo-main > .photo-box > .photo-div {
            width: 200px;
            height: 200px;
            display: inline-block;
            background: #ededed;
            margin: 2.5px;
            vertical-align: top;
            position: relative;
        }

            .photo-main > .photo-box > .photo-div > .photo-img {
                width: 200px;
                height: 200px;
            }

.photo-del {
    font-size: 0.9rem!important;
    position: absolute;
    right: -2vw;
    z-index: 1;
    top: -2vw;
    color: #da7a7a;
    background: #fddfdf;
    border-radius: 50%;
}

.photo-main > .photo-box > .add-photo {
    display: inline-block;
    margin-left: -0.83px;
    cursor: pointer;
    position: relative;
    background: #ededed;
    width: 200px;
    height: 200px;
    margin-left: -1px;
}

    .photo-main > .photo-box > .add-photo > .add-photo-img {
        display: block;
        margin: 70px auto;
    }



.creatBtn {
    position:fixed;
    bottom:0;
}

.photo-big {
    width:100%;
    background:#fff;
}
</style>